import PropTypes from 'prop-types';
import { useRef } from 'react';
import styles from './toolTip.module.scss';
import toolTipIcon from './toolTipSVGNormal.svg';
import useDetectOutsideClick from '../../hooks/useDetectOutsideClick';
import SmartImage from '../smartImage/smartImage';

export default function ToolTip({ message, style, children }) {
  const ref = useRef(null);
  const [isActive, setIsActive] = useDetectOutsideClick(ref, false);
  const onClick = () => {
    setTimeout(() => {
      setIsActive(!isActive);
    }, 1);
  };
  return (
    <div className={styles.toolTip} title={!isActive ? message : ''}>
      <div
        data-testid="help-icon"
        className={styles.toolTipOpener}
        onClick={onClick}
        aria-hidden="true"
      >
        {toolTipIcon && (
          <SmartImage
            src={toolTipIcon}
            alt="toolTip Logo"
            height={24}
            width={24}
          />
        )}
      </div>
      <div
        className={`${styles.toolTipBox} ${isActive ? styles.toolTipShow : ''}`}
        style={style || {}}
        ref={ref}
      >
        <span
          data-testid="close-icon"
          aria-hidden="true"
          onClick={onClick}
          className={styles.toolTipClose}
        >
          x
        </span>
        {message}
      </div>
      {children}
    </div>
  );
}

ToolTip.prototype = {
  message: PropTypes.string.isRequired,
  style: PropTypes.object,
  children: PropTypes.node,
};
